'use client';
import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import styles from '../styles/AuthModals.module.css';

export default function SignupModal({
  isOpen,
  onClose,
  onSwitchToLogin,
  onSubmit,
  onGoogleSignIn,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  setEmail,
  password,
  setPassword,
  captchaToken,
  setCaptchaToken,
  captchaLoading,
  setCaptchaLoading,
  captchaError,
  setCaptchaError,
  turnstileRef,
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.signupOverlay}>
      <div className={styles.signupDialog}>
        <button className={styles.modalClose} onClick={onClose}>&times;</button>
        <div className={styles.signupContainer}>
          <div className={styles.signupHeader}>
            <h1>Join PenguinLearn</h1>
          </div>
          <div className={styles.signupContent}>
            <form onSubmit={onSubmit}>
              <div className={styles.signupFields}>
                <input
                  type="text"
                  placeholder="First Name"
                  required
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  required
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
                <input
                  type="email"
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {/* CAPTCHA Verification */}
                <div className={styles.captchaContainer}>
                  {captchaLoading && (
                    <div style={{ height: '65px', backgroundColor: '#f3f4f6', borderRadius: '4px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}></div>
                  )}
                  <Turnstile
                    ref={turnstileRef}
                    siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY}
                    onSuccess={(token) => {
                      setCaptchaToken(token);
                      setCaptchaError('');
                      setCaptchaLoading(false);
                    }}
                    onError={() => {
                      setCaptchaError('CAPTCHA verification failed. Please try again.');
                      setCaptchaLoading(false);
                    }}
                    onExpire={() => {
                      setCaptchaToken('');
                      setCaptchaError('CAPTCHA expired. Please verify again.');
                    }}
                  />
                  {captchaError && (
                    <p style={{ color: '#ef4444', fontSize: '0.875rem', marginTop: '0.5rem' }}>{captchaError}</p>
                  )}
                </div>
                <div className={styles.marketingCheckbox}>
                  <input type="checkbox" id="marketingConsent" />
                  <label htmlFor="marketingConsent">
                    I agree to receive marketing communications.
                  </label>
                </div>
                <button type="submit" className={styles.signupBtn} disabled={!captchaToken || captchaLoading}>
                  Sign Up with Email
                </button>
              </div>
              <div className={styles.divider}><span>OR</span></div>
              <div className={styles.socialButtons}>
                <button
                  type="button"
                  className={`${styles.socialBtn} ${styles.googleBtn}`}
                  onClick={onGoogleSignIn}
                >
                  <img src="/images/google.png" alt="Google" className={styles.socialIcon} />
                  Sign up with Google
                </button>
              </div>
              <div className={styles.signupPrompt}>
                Already have an account?
                <button type="button" className={styles.loginLink} onClick={onSwitchToLogin}>
                  Log In
                </button>
              </div>
              <div className={styles.termsDisclaimer}>
                By clicking Sign Up, you agree to our
                <a href="#" className={styles.linkText}> Terms</a> and
                <a href="#" className={styles.linkText}> Privacy Policy</a>.
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}